module.exports = __webpack_public_path__ + "static/img/delay-icon.5fc91bcc.png";